import { useState, useEffect } from 'react'
import classNames from 'classnames'

import styles from './ScrollToTop.module.scss'

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const toggleVisibility = () => {
      const threshold = 30 * (window.innerHeight / 100)
      if (window.scrollY > threshold) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <button
      className={classNames(styles.wrapper, {
        [styles.visible]: isVisible,
      })}
      onClick={scrollToTop}
      aria-label='Scroll to top'
    >
      ↑
    </button>
  )
}

export default ScrollToTop
